import { selectCarInsurance, updateCarInsurance, uploadCarInsurance } from "../../api/config/modules/InsureFile";

const state = {
    selectCarInsurance: {},
    updateCarInsurance: {},
    uploadCarInsurance: {}
};

const mutations = {
    SET_SELECTCARINSURANCE: (state, selectCarInsurance) => {
        state.selectCarInsurance = selectCarInsurance;
    },
    SET_UPDATECARINSURANCE: (state, updateCarInsurance) => {
        state.updateCarInsurance = updateCarInsurance;
    },
    SET_UPLOADCARINSURANCE: (state, uploadCarInsurance) => {
        state.uploadCarInsurance = uploadCarInsurance;
    }
};

const actions = {
    GET_SELECTCARINSURANCE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectCarInsurance(data)
                .then((res) => {
                    commit("SET_SELECTCARINSURANCE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPDATECARINSURANCE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            updateCarInsurance(data)
                .then((res) => {
                    commit("SET_UPDATECARINSURANCE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPLOADCARINSURANCE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            uploadCarInsurance(data)
                .then((res) => {
                    commit("SET_UPLOADCARINSURANCE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
